import React from "react";
import Checkbox from "@mui/material/Checkbox";
import {
  Button,
  FormControlLabel,
  Link as MUILink,
  Stack,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const StyledStack = styled(Stack)`
  height: 100%;
  width: 80%;
  padding-top: 3em;
`;

const SigninForm = ({
  email,
  onEmailChange,
  password,
  onPasswordChange,
  remember,
  onRememberChanged,
  message,
  onSigninSubmit,
}) => {

  const handleSigninSubmit = (event) => {
    event.preventDefault();
    onSigninSubmit();
  };

  return (
    <StyledStack
      component="form"
      onSubmit={handleSigninSubmit}
      method="POST"
    >
      {message && <Typography
        variant="body1"
        textAlign="center"
        color="error"
        mb={1}
      >
        {message}
      </Typography>}

      <TextField
        type="email"
        id="email"
        name="email"
        label="Email Address"
        required={true}
        fullWidth
        value={email.value}
        onChange={onEmailChange}
        helperText={email.helperText}
        error={email.error}
        autoFocus={!email.value.length}
        margin="normal"
      />
      <Stack mb={6}>
        <TextField
          type="password"
          id="password"
          name="password"
          label="Password"
          required={true}
          fullWidth
          value={password.value}
          onChange={onPasswordChange}
          helperText={password.helperText}
          error={password.error}
          autoFocus={!!email.value.length}
          margin="normal"
        />
        <FormControlLabel
          control={
            <Checkbox
              id="remember"
              name="remember"
              checked={remember}
              onChange={onRememberChanged}
            />
          }
          label={
            <Typography variant="subtitle2">
              Remember Me
            </Typography>
          }
        />
      </Stack>
      <Stack spacing={1}>
        <Button
          type="submit"
          variant="contained"
          fullWidth
          style={{ alignSelf: "center" }}
          disabled={!email.value.length || !password.value.length}
        >
          <Typography>Sign In</Typography>
        </Button>
        <Stack
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <RouterLink to="/resetpassword">
            <MUILink
              component="span"
              variant="subtitle2"
            >
              Forgot Password?
            </MUILink>
          </RouterLink>
          <RouterLink to="/join">
            <MUILink
              component="span"
              variant="subtitle2"
            >
              Register?
            </MUILink>
          </RouterLink>
        </Stack>
      </Stack>
    </StyledStack>
  );
};

export default SigninForm;